export const slugify = (text:string):string => text
  .toString()          // Cast to string (optional)
  .normalize('NFKD')  // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
  .toLowerCase()      // Convert the string to lowercase letters
  .trim()             // Remove whitespace from both sides of a string (optional)
  .replace(/\s+/g, '-')       // Replace spaces with -
  .replace(/[^\w\-]+/g, '')   // Remove all non-word chars
  .replace(/\-\-+/g, '-')     // Replace multiple - with single -


export const scrollToTop = () => {
  window?.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
}


export function getDynamicText(text: string, variables: { [key: string]: string | number }): string {
  // Use a regular expression to find all placeholders between double curly braces
  const placeholderRegex = /\{\{([^}]+)\}\}/g

  // Replace each placeholder with the corresponding value from the variables object
  const dynamicText = text.replace(placeholderRegex, (match, placeholder) => {
    // Trim the placeholder to remove any leading or trailing spaces
    const keyName = placeholder.trim()

    // Check if the keyName exists in the variables object
    if (variables.hasOwnProperty(keyName)) {
      // If the keyName exists, return its value
      return variables[keyName].toString()
    } else {
      // If the keyName does not exist, return the original placeholder
      console.warn(`keyName: ${keyName} doesn't exist for the text: ${text}`)
      return match
    }
  })

  return dynamicText
}

export function stringToUppercase(string) {
  return string.toUpperCase()
}


export const getActualPath = (pathname: string, actualLang,  lang) => {
  const knownLocales = ['de', 'en', 'es', 'fr', 'it', 'pt']

  if (pathname === '/') return `/${lang}`

  const rootLocaleMatch = pathname.match(/^\/([a-z]{2})$/)
  if (rootLocaleMatch) return `/${lang}`

  const pathSegments = pathname.split('/').filter(Boolean)
  const detectedLang = knownLocales.includes(pathSegments[0]) ? pathSegments[0] : undefined
  const fromLang = actualLang ?? detectedLang

  if (!fromLang) return `/${lang}${pathname}`

  const suffix = pathname.replace(`/${fromLang}`, '')
  return `/${lang}${suffix}`
}
